<nav class="navbar">
  <div class="navbar-container">
    <a href="#" class="navbar-logo"><img src="assets/header.svg"></a>
  </div>
</nav>